import { Circle, cn, type CircleProps } from "@eisox/design-system";
import { QuestionMarkIcon } from "@eisox/icons";

import { HybridTooltip, type HybridTooltipProps } from "./hybrid-tooltip";

interface HelpProps extends CircleProps, Omit<HybridTooltipProps, "content" | "children"> {}

const Help: React.FC<HelpProps> = ({
  size = 21,
  backgroundColor = "gray",
  color = "darkGray",
  position,
  openingCondition,
  keepHoverOpen = false,
  forceMount,
  children,
  ...props
}) => (
  <HybridTooltip
    position={position}
    openingCondition={openingCondition}
    keepHoverOpen={keepHoverOpen}
    forceMount={forceMount}
    content={children}
    className="max-w-[350px] whitespace-pre-line"
  >
    <Circle.Root
      {...props}
      className={cn("[&_svg]:h-[10px] [&_svg]:w-[10px]", props.className)}
      size={size}
      backgroundColor={backgroundColor}
      color={color}
    >
      <QuestionMarkIcon />
    </Circle.Root>
  </HybridTooltip>
);

Help.displayName = "Help";

export { Help };
export type { HelpProps };
